"use strict";
'use client';
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useGlobalState = void 0;
var Lockr = __importStar(require("lockr"));
var react_1 = require("react");
var EVENT_STATE_CHANGE = 'stateChange';
var useGlobalState = function (key, defaultValue, enabledLocalStorage) {
    if (enabledLocalStorage === void 0) { enabledLocalStorage = true; }
    var _a = (0, react_1.useState)(function () {
        var _a;
        if (typeof window !== 'undefined')
            return enabledLocalStorage
                ? (_a = Lockr === null || Lockr === void 0 ? void 0 : Lockr.get(key)) !== null && _a !== void 0 ? _a : defaultValue
                : defaultValue;
        return defaultValue;
    }), state = _a[0], setState = _a[1];
    var changeState = (0, react_1.useCallback)(function (data) {
        var _a;
        if (typeof window !== 'undefined')
            (_a = window === null || window === void 0 ? void 0 : window.dispatchEvent) === null || _a === void 0 ? void 0 : _a.call(window, new CustomEvent(EVENT_STATE_CHANGE, {
                detail: { key: key, value: data },
            }));
    }, [key]);
    (0, react_1.useEffect)(function () {
        var _a;
        var changeStateHandler = function (e) {
            if (e.detail.key === key) {
                setState(e.detail.value);
                if (enabledLocalStorage)
                    Lockr.set(key, e.detail.value);
            }
        };
        if (typeof window !== 'undefined')
            (_a = window === null || window === void 0 ? void 0 : window.addEventListener) === null || _a === void 0 ? void 0 : _a.call(window, EVENT_STATE_CHANGE, changeStateHandler);
        return function () {
            var _a;
            if (typeof window !== 'undefined')
                (_a = window === null || window === void 0 ? void 0 : window.removeEventListener) === null || _a === void 0 ? void 0 : _a.call(window, EVENT_STATE_CHANGE, changeStateHandler);
        };
    }, [key]);
    return (0, react_1.useMemo)(function () { return ({
        state: state,
        changeState: changeState,
    }); }, [state, changeState]);
};
exports.useGlobalState = useGlobalState;
